import { v4 as uuidv4 } from 'uuid'
import { formatMoney as shopifyFormatMoney } from './currency-formatter'

function generateID() {
  return uuidv4()
}

function parseJSON(input: string | object, defaultReturnType = 'object') {
  if (typeof input === 'object') return input
  if (!input) return defaultReturnType === 'object' ? {} : []
  try {
    return JSON.parse(input.replace(/(&quot;)/g, '"'))
  } catch (err) {
    console.error('Could not parse input in parseJSON.', parseJSON, err)
    return defaultReturnType === 'object' ? {} : []
  }
}

const globalState = window.globals
const formatMoney = function (cents: number | string, format = globalState.shopify.moneyFormat) {
  return shopifyFormatMoney(cents, format)
}

export {
  formatMoney,
  globalState,
  parseJSON,
  generateID
}
